
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, TextField } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { useCategoriaXID } from "../../../hooks/cache";
import { AvatarScreen } from "../../ui";
import { BotonesAndCargando } from "../../components/botones";
import { useImagenStore } from "../../../stores";
import { startEditarCategoria } from "../../../services";

import { useQueryClient } from "@tanstack/react-query";
import Swal from "sweetalert2";



const initCategoria = {
    nombre: "",
    tags: "",
    primero: 0,
    segundo: 0,
    tercero: 0,
    cuarto: 0,
    quinto: 0,
    sexto: 0,
    septimo: 0,
};



export const ActualizarCategoria = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { data } = useCategoriaXID(id);
    const { imagen, valorImagen } = useImagenStore();
    const [cargando, setCargando] = useState(false);
    const [ formCategoria, setFormCategoria ] = useState( initCategoria );

    const { 
        nombre,
        tags,
        primero,
        segundo,
        tercero,
        cuarto,
        quinto,
        sexto,
        septimo,   
    } = formCategoria;


    const handleInputChange = ({ target }) => {
        setFormCategoria({
            ...formCategoria,
            [target.name]: target.value
        });
    }



    useEffect( () => {
        if( data ){
            setFormCategoria(data);
            valorImagen(data.img)
        }
    }, [data]);




    const handleActualizarCategoria = async(e) => {
        e.preventDefault();
        const { isConfirmed } = await Swal.fire({
            title: 'Actualizar Categoria',
            text: `¿Está seguro de actualizar este categoria?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, actualizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startEditarCategoria({ ...formCategoria, id, img: imagen });
        setCargando(false);
        if(resp) { queryClient.invalidateQueries({ queryKey: ['categorias-todos'] }) }
    }




    return (

        <LayoutCrearDoc titulo='Actualizar Categoria' add={false}>
            <form onSubmit={ handleActualizarCategoria } >
                {/* <MostrarImagen /> */}
                <AvatarScreen carpeta="categorias" />

                <Grid container spacing={4} sx={{mt:3}}>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Nombre'
                            type='text'
                            placeholder='Nombre'
                            fullWidth
                            name="nombre"
                            value={ nombre }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Primero'
                            type='number'
                            placeholder='Primero'
                            fullWidth
                            name="primero"
                            value={ primero }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Segundo'
                            type='number'
                            placeholder='Segundo'
                            fullWidth
                            name="segundo"
                            value={ segundo }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Tercero'
                            type='number'
                            placeholder='Tercero'
                            fullWidth
                            name="tercero"
                            value={ tercero }
                            onChange={ handleInputChange } 
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Cuarto'
                            type='number'
                            placeholder='Cuarto'
                            fullWidth
                            name="cuarto"
                            value={ cuarto }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Quinto'
                            type='number'
                            placeholder='Quinto'
                            fullWidth
                            name="quinto"
                            value={ quinto }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Sexto'
                            type='number'
                            placeholder='Sexto'
                            fullWidth
                            name="sexto"
                            value={ sexto }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Septimo'
                            type='number'
                            placeholder='Septimo'
                            fullWidth
                            name="septimo"
                            value={ septimo }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField required
                            variant="outlined"
                            label='Tags (Separar con Coma)'
                            multiline
                            type='number'
                            placeholder='Tags (Separar con Coma)'
                            fullWidth
                            name="tags"
                            value={ tags }
                            rows={3}
                            onChange={ handleInputChange } 
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Actualizar Categoria'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>
    )
}
